if (!customElements.get('lisa-beanie-picker')) {
  customElements.define('lisa-beanie-picker', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) { window.LisaSales?.watch(this, this.refreshPrices); return; }
      const select = this.querySelector('select');
      const data = this.querySelector('[data-beanie-variants]');
      const strings = document.getElementById('LisaBeanieStrings');
      if (!select || !data || !strings) return;
      const variants = JSON.parse(data.textContent);
      const allLabels = JSON.parse(strings.textContent);
      const singles = variants.filter(v => /^(CAP-(?:FAITH|EAGLE)|CORD-\d+|AA296|RHIN-POM|GLOVE-CLOTH|GLOVE-WOMEN|GLOVE-INSULATED|EARMUFF-PLUSH|TRAPPER-MASK|BEANIE-INSULATED|FACE-MASK|NINJA-MASK|BEANIE-AWARENESS|SCARF-INFINITY|SCARF-BRAIDED|WT-(?:HAT|PAIR|SCARF|HOOD)-\d+)-SINGLE-/.test(v.sku || ''));
      const dozens = variants.filter(v => [67822456537277, 67823206662333, 67801831604413, 67812588126397, 42428635807933, 42459525447869, 42459526463677, 67812599201981, 42433754071229, 67745062191293, 42428629942461, 67745062224061].includes(Number(v.id)) || /^(CORD-\d+|FACE-MASK|SCARF-INFINITY|SCARF-BRAIDED|WT-(?:HAT|PAIR|SCARF|HOOD)-\d+)-DOZEN-/.test(v.sku || ''));
      const dozen = dozens[0];
      if (!singles.length || !dozen) return;
      const pairs = /^(GLOVE-|EARMUFF-|WT-PAIR-)/.test(singles[0].sku);
      const oneColor = new Set(singles.map(v => v.sku.replace(/-SIZE-\d+$/, ''))).size === 1;
      const assorted = singles.every(v => v.sku.endsWith('-SINGLE-ASSORTED'));
      const sizeOf = v => (v.sku || '').match(/-SIZE-(\d+)$/)?.[1];
      const sizesAvailable = [...new Set(singles.map(sizeOf).filter(Boolean))];
      const coloredDozen = singles[0].sku.startsWith('FACE-MASK-');
      const masks = /^(FACE|NINJA)-MASK-/.test(singles[0].sku);
      const scarves = /^(SCARF-|WT-SCARF-)/.test(singles[0].sku);
      const baseLabels = {...allLabels, ...allLabels.winter};
      const labels = singles[0].sku.startsWith('CAP-') ? {...baseLabels, ...allLabels.caps} : singles[0].sku.startsWith('CORD-') ? {...baseLabels, ...allLabels.cords} : singles[0].sku.startsWith('WT-HOOD-') ? {...baseLabels, ...allLabels.hoods} : scarves ? {...baseLabels, ...allLabels.scarves} : masks ? {...baseLabels, ...allLabels.masks} : pairs ? {...baseLabels, ...allLabels.gloves} : baseLabels;
      this.ready = true;
      const id = select.id || `beanie-${Math.random().toString(36).slice(2)}`;
      const currency = window.Shopify?.currency?.active || 'USD';
      const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency}).format(cents / 100);
      const make = (tag, className, text) => {
        const el = document.createElement(tag);
        if (className) el.className = className;
        if (text) el.textContent = text;
        return el;
      };
      const fieldset = make('fieldset', 'lisa-beanie__packs');
      fieldset.append(make('legend', 'form__label', labels.buy));
      const packInputs = [];
      const packDisplays = {};
      const saleData = this.querySelector('[data-lisa-sale-product]') || this.closest('.product__info-container')?.querySelector('[data-lisa-sale-product]');
      const saleProduct = this.saleProduct || (saleData ? JSON.parse(saleData.textContent) : null);
      [
        ['single', labels.single, singles[0].price, assorted ? labels.assorted : oneColor ? labels.black_pair : labels.choose, singles.some(v => v.available)],
        ['dozen', labels.dozen, dozen.price, `${labels.pack} · ${money(dozen.price / 12)} ${labels.each}`, dozens.some(v => v.available)]
      ].forEach(([kind, title, price, detail, available]) => {
        const label = make('label', 'lisa-beanie__pack');
        const input = make('input');
        input.type = 'radio'; input.name = `${id}-pack`; input.value = kind;
        input.disabled = !available;
        label.append(input, make('span', 'lisa-beanie__pack-title', title), make('strong', 'lisa-beanie__pack-price', money(price)), make('small', 'lisa-beanie__pack-detail', available ? detail : labels.sold_out));
        fieldset.append(label); packInputs.push(input);
        packDisplays[kind] = {price: label.querySelector('.lisa-beanie__pack-price'), detail: label.querySelector('.lisa-beanie__pack-detail')};
      });
      const colors = make('fieldset', 'lisa-beanie__colors');
      const legend = make('legend', 'form__label');
      const currentColor = make('strong');
      legend.append(document.createTextNode(`${labels.color}: `), currentColor);
      colors.append(legend);
      const swatches = make('div', 'lisa-beanie__swatches');
      const colorInputs = [];
      const palette = {'Black':'#191919','Charcoal gray':'#4b4c4f','Red':'#d3112b','Burgundy':'#7e1634','Tan':'#c4a371','Olive green':'#424b27','Light gray':'#b8bab9','Brown':'#59402d','Navy':'#182b4c','Ivory':'#eee8d8','Dark brown':'#3b2922','Pink':'#dfa6b5','Lavender':'#b5a0c9','Purple':'#705080','Gray':'#858587','Beige':'#d2bd91','White':'#f7f4ee','Light pink':'#f4d5d4','Dusty rose':'#b58287','Taupe':'#a49688','Cream':'#eee8d8','Royal blue':'#1744d6','Camouflage':'#626347','Hot pink':'#f4097c','Dark green':'#28534a','Slate blue':'#4b5673','Cream / Beige':'#eee8d8','Turquoise / Blue':'#169baf','Gray / Olive':'#8b8c87','Light blue':'#b5d3e4','Lime green':'#8fce23','Black / Blue':'#191919','Royal blue / Black':'#1744d6','Navy / Blue':'#182b4c','Pink / Gray':'#e21b86','Orange / Blue':'#f15b18','Gray / Black':'#6d6f7d','Pink / Aqua':'#ee9fbd','Olive / Black':'#5a6338','Red / Navy':'#c41635','Assorted':'#888'};
      const colorOf = v => Object.keys(palette).find(color => (v.sku || '').split(/-(?:SINGLE|DOZEN)-/)[1]?.replace(/-SIZE-\d+$/, '') === color.toUpperCase().replaceAll(' / ', '-').replaceAll(' ', '-'));
      const colorVariants = singles.filter((v, i) => singles.findIndex(candidate => colorOf(candidate) === colorOf(v)) === i);
      colorVariants.forEach(v => {
        const color = colorOf(v);
        const label = make('label', 'lisa-beanie__swatch');
        label.title = labels.colors[color] || color;
        const input = make('input');
        input.type = 'radio'; input.name = `${id}-color`; input.value = v.option1 || v.options[0]; input.disabled = !v.available;
        const chip = make('span', 'lisa-beanie__chip');
        chip.style.setProperty('--swatch', palette[color] || '#777');
        if (color === 'Camouflage') chip.style.background = 'linear-gradient(135deg,#30382e 0 25%,#777c52 25% 50%,#66513b 50% 75%,#3b4334 75%)';
        const splitColors = {'Cream / Beige':['#eee8d8','#b3a58d'],'Turquoise / Blue':['#169baf','#456b87'],'Gray / Olive':['#999b98','#535b3e'],'Black / Blue':['#191919','#245dbb'],'Royal blue / Black':['#1744d6','#191919'],'Navy / Blue':['#182b4c','#245dbb'],'Pink / Gray':['#e21b86','#62646c'],'Orange / Blue':['#f15b18','#087ea6'],'Gray / Black':['#6d6f7d','#191919'],'Pink / Aqua':['#ee9fbd','#40bbc6'],'Olive / Black':['#5a6338','#191919'],'Red / Navy':['#c41635','#142641']};
        if (splitColors[color]) chip.style.background = `linear-gradient(135deg,${splitColors[color][0]} 0 50%,${splitColors[color][1]} 50% 100%)`;
        chip.setAttribute('aria-hidden', 'true');
        label.append(input, chip, make('span', 'visually-hidden', label.title));
        swatches.append(label); colorInputs.push(input);
      });
      colors.append(swatches);
      const sizes = make('fieldset', 'lisa-beanie__colors');
      sizes.append(make('legend', 'form__label', labels.size));
      const sizeInputs = [];
      const sizeButtons = make('div', 'lisa-pom__pills');
      sizesAvailable.forEach(size => {
        const label = make('label', 'lisa-pom__pill');
        const input = make('input');
        input.type = 'radio'; input.name = `${id}-size`; input.value = size;
        label.append(input, make('span', '', `${size} cm`));
        sizeButtons.append(label); sizeInputs.push(input);
      });
      sizes.append(sizeButtons);
      const note = make('p', 'lisa-beanie__note');
      note.setAttribute('aria-live', 'polite');
      this.prepend(fieldset, colors, sizes, note);
      this.querySelector('[data-beanie-native]').hidden = true;
      let lastSingle = singles.find(v => v.available) || singles[0];
      this.refreshPrices = () => {
        for (const kind of ['single', 'dozen']) {
          const target = kind === 'single' ? lastSingle : coloredDozen ? (dozens.find(v => colorOf(v) === colorOf(lastSingle)) || dozen) : dozen;
          const display = packDisplays[kind];
          const price = window.LisaSales?.renderPrice(display.price, saleProduct, target);
          if (!price) display.price.textContent = money(target.price);
          if (kind === 'dozen') display.detail.textContent = target.available ? `${labels.pack} · ${money((price?.current ?? target.price) / 12)} ${labels.each}` : labels.sold_out;
        }
      };
      const sync = () => {
        const variant = variants.find(v => (v.option1 || v.options[0]) === select.value) || dozen;
        const single = singles.includes(variant);
        if (single) lastSingle = variant;
        else if (coloredDozen) lastSingle = singles.find(v => colorOf(v) === colorOf(variant)) || lastSingle;
        packInputs.forEach(input => {input.checked = input.value === (single ? 'single' : 'dozen');});
        colorInputs.forEach(input => {
          const singleVariant = singles.find(v => (v.option1 || v.options[0]) === input.value);
          const target = !single && coloredDozen ? dozens.find(v => colorOf(v) === colorOf(singleVariant)) : singles.find(v => colorOf(v) === colorOf(singleVariant) && sizeOf(v) === sizeOf(lastSingle));
          input.checked = colorOf(singleVariant) === colorOf(lastSingle);
          input.disabled = !target?.available;
        });
        colors.hidden = (!single && !coloredDozen) || oneColor;
        sizes.hidden = !single || !sizesAvailable.length;
        sizeInputs.forEach(input => { input.checked = input.value === sizeOf(lastSingle); input.disabled = !singles.some(v => colorOf(v) === colorOf(lastSingle) && sizeOf(v) === input.value && v.available); });
        this.refreshPrices();
        const color = colorOf(lastSingle);
        currentColor.textContent = labels.colors[color] || color;
        note.textContent = single ? (oneColor ? labels.single_black_note : labels.single_note) : (oneColor ? labels.dozen_black_note : labels.dozen_note);
        if (assorted) note.textContent = single ? labels.single_assorted_note : labels.dozen_note;
        if (sizesAvailable.length) note.textContent = single ? labels.single_size_note : labels.dozen_sizes_note;
        if (single && variant.sku.startsWith('BEANIE-AWARENESS-')) note.textContent += ` ${labels.assortment_photo_note}`;
        if (single && variant.sku === 'GLOVE-CLOTH-SINGLE-GRAY') note.textContent += ` ${labels.gray_photo_note}`;
      };
      fieldset.addEventListener('change', event => {
        const variant = event.target.value === 'single' ? lastSingle : coloredDozen ? (dozens.find(v => colorOf(v) === colorOf(lastSingle)) || dozen) : dozen;
        select.value = variant.option1 || variant.options[0];
        select.dispatchEvent(new Event('change', {bubbles:true}));
      });
      colors.addEventListener('change', event => {
        const picked = singles.find(v => (v.option1 || v.options[0]) === event.target.value);
        const isDozen = packInputs.find(input => input.value === 'dozen').checked;
        const target = isDozen && coloredDozen ? dozens.find(v => colorOf(v) === colorOf(picked)) : singles.find(v => colorOf(v) === colorOf(picked) && sizeOf(v) === sizeOf(lastSingle));
        if (!target) return;
        select.value = target.option1 || target.options[0];
        select.dispatchEvent(new Event('change', {bubbles:true}));
      });
      sizes.addEventListener('change', event => {
        const variant = singles.find(v => colorOf(v) === colorOf(lastSingle) && sizeOf(v) === event.target.value);
        if (!variant) return;
        select.value = variant.option1 || variant.options[0];
        select.dispatchEvent(new Event('change', {bubbles:true}));
      });
      select.addEventListener('change', sync);
      sync();
      // Fresh product visits start with a single; explicit variant links keep their selection.
      if (!this.closest('[role="dialog"]') && !new URLSearchParams(window.location.search).has('variant')) {
        const selectDefault = () => {
          if (!this.isConnected) return;
          const single = singles.find(v => v.available);
          if (!single || select.value === (single.option1 || single.options[0])) return;
          select.value = single.option1 || single.options[0];
          select.dispatchEvent(new Event('change', {bubbles:true}));
        };
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', selectDefault, {once:true});
        else selectDefault();
      }
      window.LisaSales?.watch(this, this.refreshPrices);
    }
  });
}
